import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { buttonRecipe, ButtonRecipeRecipe, ButtonRecipeVariantProps } from "@fenderdigital/ui-styled-system/recipes";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { css, cx } from "styled-system/css";

@Component({
  selector: "fui-button",
  templateUrl: "button.component.html",
  standalone: false,
})
export class FuiButtonComponent extends BaseComponent implements OnInit {
  public usePanda: boolean = false;
  @Input() text: string;
  @Input() props: ButtonRecipeVariantProps = {};
  @Input() color: string;
  @Input() theme: string = "dark";
  @Input() extraClasses: string;
  @Input() disabled: boolean = false;
  @Input() type: string = "button";
  @Output() click = new EventEmitter<void>();
  buttonRecipe = buttonRecipe;
  public value: any;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {
    if (this.usePanda) {
      if (this.color) {
        this.value = cx(this.buttonRecipe({ ...this.props }), css({ color: this.color }));
      } else {
        this.value = this.buttonRecipe(this.props);
      }
    } else {
      this.value = "fui-button " + this.theme;
    }
    if (this.extraClasses) {
      this.value = this.value + " " + this.extraClasses;
    }
  }
}
